import React from 'react';
export default function ContactFormButton({
	text = 'Get a Free Estimate Today',
	className = 'mt-8 px-6 py-3 bg-transparent border-4 border-primary text-primary font-semibold text-lg rounded-sm hover:bg-primary-600 hover:text-white hover:border-primary-600 transition ease-in duration-300',
}) {
	return (
		<div
			onClick={(e) => {
				e.preventDefault();
				document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
				window.location.hash = '#contact';
			}}
		>
			<button
				id='menu-toggle'
				className={className}
			>
				{text}
			</button>
		</div>
	);
}
